import DOMUtils from "@utils/dom.utils";
import ScrollUtils from "@utils/scroll.utils";
import i18n from "@plugins/i18n.ts";

export default {
  methods: {
    showEditorError(errorCode) {
      switch (errorCode) {
        case "AccessDenied":
          this.$router.push({ name: "Forbidden" });
          break;
        case "RedirectToCGPendingReviewPlaceholder":
          break;
        case "LessonUnpublished":
          this.$router.replace({ name: "EditorUnpublishedPage" });
          break;
        case "LessonNotFound":
        case "AssignmentNotFound":
        case "not-found":
          this.$router.push({ name: "PageNotFound" });
          break;
        default:
          this.showErrorToast(i18n.t("api_action_generic_error_message"));
          break;
      }
    },
    showErrorToast(message) {
      this.$toast.show("error", {
        kind: "error",
        title: message,
      });
    },
    scrollToFirstFormError() {
      this.$nextTick(() => {
        const errors = DOMUtils.elOf(this.$el, ".message-component.message.error");
        if (errors.length > 0) {
          const ele = DOMUtils.parent(errors[0], ".field-input");
          if (ele) {
            ScrollUtils.scrollToView(ele);
          } else {
            ScrollUtils.scrollToView(errors[0]);
          }
        }
      });
    },
  },
};
